import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import ItemContent from '../../../components/ItemContent/ItemContent';
import { EPaths } from '../../../types/enums/EPaths';
import { IEditForm } from '../../../types/interfaces/IEditForm';
import { endpoints } from '../../../utils/endpoints';
import tPaths from '../../../utils/tPaths';
import LabelWithPars from '../../../components/LabelWithPars/LabelWithPars';
import useDescLangs from '../../../utils/useDescLangs';
import { useMemoOne } from 'use-memo-one';
import { CircularProgress } from '@material-ui/core';
import { useParams } from 'react-router-dom';
import { ETables } from '../../../types/enums/ETables';

const EditNotification = () => {
  const { id } = useParams<{ id: string }>();
  console.log(`id:`, id);
  const { t } = useTranslation();
  const { languagesList, reduceLangsList } = useDescLangs();

  const dataMapper = useCallback(
    (data: any, lang: string): IEditForm[][] => [
      [
        {
          type: 'input',
          fieldName: 'title',
          label: <LabelWithPars label={t(tPaths.editFormLabels.title)} info={lang.toUpperCase()} />,
          initialValue: data.title[lang],
        },
        {
          type: 'input',
          fieldName: 'body',
          label: <LabelWithPars label={t(tPaths.editFormLabels.body)} info={lang.toUpperCase()} />,
          multiline: true,
          initialValue: data.body[lang],
        },
        {
          type: 'input',
          fieldName: 'iosDeepLink',
          label: t(tPaths.editFormLabels.iosDeepLink),
          initialValue: data.iosDeepLink,
        },
        {
          type: 'input',
          fieldName: 'androidDeepLink',
          label: t(tPaths.editFormLabels.androidDeepLink),
          initialValue: data.androidDeepLink,
        },
      ],
    ],
    [t],
  );

  const updateDataFormatter = useCallback(
    (fields: any) => ({
      title: reduceLangsList(fields, 'title'),
      body: reduceLangsList(fields, 'body'),
      iosDeepLink: fields.en.iosDeepLink.value,
      androidDeepLink: fields.en.androidDeepLink.value,
    }),
    [reduceLangsList],
  );

  const tabs = useMemoOne(
    () => [...languagesList.map((lang) => ({ key: lang.key, label: lang.display }))],
    [languagesList, t],
  );

  const tabsContentMapper = useCallback(
    (data: any) => ({
      ...languagesList.reduce(
        (acc, cv) => ({
          ...acc,
          [cv.key]: dataMapper(data, cv.key),
        }),
        {},
      ),
    }),
    [dataMapper, languagesList],
  );

  const switches = useMemoOne(() => [], [t]);
  const switchesDataMapper = useCallback((data: any) => ({}), []);

  return (
    <>
      {languagesList.length ? (
        <ItemContent
          itemId={id}
          title={t(tPaths.itemContent.addNotification)}
          path={ETables.InAppNotifications}
          //   contentMapper={dataMapper}
          switches={switches}
          switchesDataMapper={switchesDataMapper}
          tabs={tabs}
          tabsContentMapper={tabsContentMapper}
          updateDataFormatter={updateDataFormatter}
          //editable
        />
      ) : (
        <CircularProgress />
      )}
    </>
  );
};

export default EditNotification;
